// extracted by mini-css-extract-plugin
module.exports = {"button":"category-create-modal_button_3SHND"};